import { NgModule } from "@angular/core";
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { UserListComponent } from './system/user/user-list/user-list.component';
import { SaleProcessComponent } from './sale/sale-process/sale-process.component';
import { SaleShopComponent } from './sale/sale-shop/sale-shop.component';
import { WeightComponent } from './sale/setting/weight/weight.component';
import { TickComponent } from './sale/setting/tick/tick.component';
import { AreaComponent } from './sale/setting/area/area.component';
import { FloorWeightComponent } from './sale/setting/floor-weight/floor-weight.component';
import { InstallPlaceComponent } from './sale/setting/install-place/install-place.component';
import { CraterComponent } from './sale/setting/crater/crater.component';
import { DesignComponent } from './sale/setting/design/design.component';
import { TipComponent } from './sale/setting/tip/tip.component';
import { InstallCeilComponent } from './sale/setting/install-ceil/install-ceil.component';
import { InstallStructureComponent } from './sale/setting/install-structure/install-structure.component';
import { InstallRunPositionComponent } from './sale/setting/install-run-position/install-run-position.component';
import { InstallSiteComponent } from './sale/setting/install-site/install-site.component';
import { InstallOpenCraterComponent } from './sale/setting/install-open-crater/install-open-crater.component';
import { InstallHeightComponent } from './sale/setting/install-height/install-height.component';
import { ServerBackendListComponent } from './service/server-backend/server-backend-list/server-backend-list.component';
import { ShopFloorComponent } from './sale/setting/shop-floor/shop-floor.component';
import { UserCateComponent } from './system/user/user-cate/user-cate.component';
import { UserJobComponent } from './system/user/user-job/user-job.component';
import { SaleLsfPagesComponent } from './sale/sale-factor/sale-lsf/sale-lsf-pages/sale-lsf-pages.component';
import { CrmTaskComponent } from './site/crm/crm-task/crm-task.component';
import { SiteCrmCoopComponent } from './site/site-crm/site-crm-coop/site-crm-coop.component';
import { SiteCrmProjectComponent } from './site/site-crm/site-crm-project/site-crm-project.component';
import { SiteCrmVisitComponent } from './site/site-crm/site-crm-visit/site-crm-visit.component';
import { UserUvalueComponent } from './system/user/user-uvalue/user-uvalue.component';
import { DashboardComponent } from './home/dashboard/dashboard.component';
import { SalePaymentListComponent } from './sale/sale-payments/sale-payment-list/sale-payment-list.component';
import { UserGroupsComponent } from './system/user/user-groups/user-groups.component';
import { CardexListComponent } from './system/wharehouse/wharehouse-cardex/cardex-list/cardex-list.component';
import { MaterialListComponent } from './system/wharehouse/wharehouse-material/material-list/material-list.component';
import { WharehouseOrderStatusComponent } from './system/wharehouse/wharehouse-order-status/wharehouse-order-status.component';
import { OrderListComponent } from './system/wharehouse/wharehouse-order/order-list/order-list.component';
import { WharehouseMaterialCateComponent } from './system/wharehouse/wharehouse-material-cate/wharehouse-material-cate.component';
import { WharehouseCostCenterComponent } from './system/wharehouse/wharehouse-cost-center/wharehouse-cost-center.component';
import { ExitListComponent } from './system/wharehouse/wharehouse-exit/exit-list/exit-list.component';
import { InvoiceListComponent } from './system/wharehouse/wharehouse-invoice/invoice-list/invoice-list.component';
import { WharehouseInvoiceTypeComponent } from './system/wharehouse/wharehouse-invoice-type/wharehouse-invoice-type.component';
import { WharehousePlaceComponent } from './system/wharehouse/wharehouse-place/wharehouse-place.component';
import { WharehouseMaterialCate2Component } from './system/wharehouse/wharehouse-material-cate2/wharehouse-material-cate2.component';
import { WharehouseMaterialCate3Component } from './system/wharehouse/wharehouse-material-cate3/wharehouse-material-cate3.component';
import { WharehouseWeightComponent } from './system/wharehouse/wharehouse-weight/wharehouse-weight.component';
import { CkdListComponent } from './sale/ckd-list/ckd-list.component';
import { CdkStatusComponent } from './sale/cdk-status/cdk-status.component';
import { CkdInvoiceComponent } from './sale/ckd-invoice/ckd-invoice.component';
import { SiteMaterialListPrintComponent } from './sale/site-material-list-print/site-material-list-print.component';
import { CkdLetterComponent } from './sale/ckd-letter/ckd-letter.component';
import { CkdMaterialList2Component } from './sale/ckd-material-list2/ckd-material-list2.component';
import { SaleInvoiceComponent } from './sale/sale-factor/sale-invoice/sale-invoice.component';
import { TipCateComponent } from './sale/tip-cate/tip-cate.component';
import { TipListComponent } from './sale/tip-list/tip-list.component';
import { CkdInvoice2Component } from './sale/ckd-invoice2/ckd-invoice2.component';


const routes: Routes = [
  { path: "tr-ckd/:token", component: CkdInvoiceComponent },
  { path: "invoice2/:token", component: CkdInvoice2Component },
  { path: "ckd-list/:token", component: SiteMaterialListPrintComponent },
  { path: "ckd-letter/:token", component: CkdLetterComponent },
  { path: "sale-invoice/:id", component: SaleInvoiceComponent },

  {
    path: "home", component: HomeComponent, children: [
      { path: "user/:id", component: UserListComponent },
      { path: "weight/:id", component: WeightComponent },
      { path: "tick/:id", component: TickComponent },
      { path: "area/:id", component: AreaComponent },
      { path: "floor-weight/:id", component: FloorWeightComponent },
      { path: "install-place/:id", component: InstallPlaceComponent },
      { path: "shop-floor/:id", component: ShopFloorComponent },
      { path: "crater/:id", component: CraterComponent },
      { path: "design/:id", component: DesignComponent },
      { path: "tip/:id", component: TipComponent },
      { path: "install-ceil-type/:id", component: InstallCeilComponent },
      { path: "install-structure-type/:id", component: InstallStructureComponent },
      { path: "install-run-position/:id", component: InstallRunPositionComponent },
      { path: "install-site/:id", component: InstallSiteComponent },
      { path: "install-open-crater/:id", component: InstallOpenCraterComponent },
      { path: "install-height/:id", component: InstallHeightComponent },
      { path: "project-backend", component: ServerBackendListComponent },
      { path: "sale/:id/:type/:code", component: SaleLsfPagesComponent },
      { path: "process/:id", component: SaleProcessComponent },
      { path: "shop/:id", component: SaleShopComponent },
      { path: "cate/:id", component: UserCateComponent },
      { path: "job/:id", component: UserJobComponent },
      { path: "crm-task/:id", component: CrmTaskComponent },
      { path: "crm-coop/:id", component: SiteCrmCoopComponent },
      { path: "crm-project/:id", component: SiteCrmProjectComponent },
      { path: "crm-visit/:id", component: SiteCrmVisitComponent },
      { path: "uvalue/:id", component: UserUvalueComponent },
      { path: "dashboard/:id", component: DashboardComponent },
      { path: "payment/:id", component: SalePaymentListComponent },
      { path: "groups/:id", component: UserGroupsComponent },

      { path: "material-cate/:id", component: WharehouseMaterialCateComponent },
      { path: "material/:id", component: MaterialListComponent },
      { path: "order-status/:id", component: WharehouseOrderStatusComponent },
      { path: "order/:id", component: OrderListComponent },
      { path: "cost-center/:id", component: WharehouseCostCenterComponent },
      { path: "exit/:id", component: ExitListComponent },
      { path: "invoice/:id", component: InvoiceListComponent },
      { path: "invoice/:id/:type", component: InvoiceListComponent },
      { path: "invoice-type/:id", component: WharehouseInvoiceTypeComponent },
      { path: "cardex/:id", component: CardexListComponent },
      { path: "wplace/:id", component: WharehousePlaceComponent },
      { path: "material-cate2/:id", component: WharehouseMaterialCate2Component },
      { path: "material-cate3/:id", component: WharehouseMaterialCate3Component },
      { path: "wharehouse-weight/:id", component: WharehouseWeightComponent },
      { path: "ckd/:id", component: CkdListComponent },
      { path: "ckd-status/:id", component: CdkStatusComponent },
      { path: "ckd-material2/:id", component: CkdMaterialList2Component },
      { path: "tip-cate/:id", component: TipCateComponent },
      { path: "tip-list/:id", component: TipListComponent },


    ]
  },
  { path: "login", component: LoginComponent },
  { path: "", component: LoginComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class appRoutingModule {

}